import { render, staticRenderFns } from "./tag_view.vue?vue&type=template&id=70233c39&scoped=true&"
import script from "./tag_view.vue?vue&type=script&lang=js&"
export * from "./tag_view.vue?vue&type=script&lang=js&"
import style0 from "./tag_view.vue?vue&type=style&index=0&id=70233c39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70233c39",
  null
  
)

export default component.exports